/* istanbul ignore next */
export { default } from './ErrorModal';
